import { SpotlightContent } from './SpotlightContent';
import { redirectToPayrollDashboard } from '../../utils/redirect';
import {
  dispatchSpotlighAtWorkSimulationEvent,
  dispatchSimulateButtonClickEvent,
} from '../../utils/analyticsEvents';
import { useSpotlight, SpotlightStatus } from './useSpotlight';
import { useHasPayrollProduct } from '../../hooks/queries/useHasPayrollProduct';
import { openFlows } from '../../utils/flows';
import { openSimulator } from '../../utils/simulator';
import { ButtonDefault } from './ButtonDefault/ButtonDefault';

const Spotlight = (): JSX.Element => {
  const { status, isSuccess, spotlightProps } = useSpotlight();
  const payroll = useHasPayrollProduct();

  const redirectToAtWorkCallback = (): void => {
    dispatchSpotlighAtWorkSimulationEvent();
    redirectToPayrollDashboard();
  };

  const handleAtWorkClick = (): void => {
    openFlows(redirectToAtWorkCallback);
  };

  const handleSimulateClick = (): void => {
    if (payroll.isSuccess && payroll.data) {
      handleAtWorkClick();
      return;
    }

    dispatchSimulateButtonClickEvent();
    openSimulator();
  };

  if (isSuccess && status === SpotlightStatus.ACTIVE) {
    return <SpotlightContent marginTop={{ _: '12px', '5xl': '54px' }} {...spotlightProps} />;
  }

  if (isSuccess && status === SpotlightStatus.DEFAULT) {
    return (
      <>
        <SpotlightContent marginTop={{ _: '60px', '5xl': '70px' }} {...spotlightProps} />
        <ButtonDefault onClick={handleSimulateClick} />
      </>
    );
  }

  return <></>;
};

export { Spotlight };
